module.exports = __webpack_public_path__ + "img/header-engagementRingsTensionRing@2x.b390f21.jpg";